import { useMemo } from "react";

import { match } from "ts-pattern";

import MysqlLogoSourceIconDark from "../../assets/components/sources/MysqlLogoSourceIconDark";
import MysqlLogoSourceIconLight from "../../assets/components/sources/MysqlLogoSourceIconLight";
import { GalaxyTheme } from "../../theme/constants";
import { useGalaxyTheme } from "../../theme/GalaxyTheme";

const MySQLLogomark = ({ height }: { height: number }) => {
  const { galaxyTheme } = useGalaxyTheme();

  const logo = useMemo(() => {
    return match(galaxyTheme)
      .with(GalaxyTheme.DARK, () => <MysqlLogoSourceIconLight height={height} />)
      .with(GalaxyTheme.LIGHT, () => <MysqlLogoSourceIconDark height={height} />)
      .exhaustive();
  }, [galaxyTheme, height]);

  return logo;
};

export default MySQLLogomark;
